module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/23_2c5ab40775177e57f287ead59ead7969.jpg";